<template>
	<div class="el-table__header-wrapper el-table__body-wrapper is-scroll-left">
		<table border="1" class="el-table__header custom-lock" style="width: 100%">
			<tr>
				<th style="text-align: center; background: #a1ccef;font-weight: bold;">Economía</th>
				<th style="text-align: center;background: #a1ccef;font-weight: bold;">Imparcialidad</th>
			</tr>
			<tr>
				<td class="custom-padding">
					<el-form-item
							label=" "
							prop="provider_selected.economicJustification"
							:rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

					<el-input type="textarea"
					          :autosize="{ minRows: 4, maxRows: 8}"
							  resize="none"
					          v-model="requestForm.provider_selected.economicJustification"
					          :disabled="providerActive == '' ||  onlyRead== true ? true: false"/>

					</el-form-item>
				</td>
				<td class="custom-padding">
					<el-form-item
							label=" "
							prop="provider_selected.impartialityJustification"
							:rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

					<el-input type="textarea"
					          :autosize="{ minRows: 4, maxRows: 8}"
							  resize="none"
					          v-model="requestForm.provider_selected.impartialityJustification"
					          :disabled="providerActive == '' ||  onlyRead== true ? true: false"/>
					</el-form-item>
				</td>
			</tr>


			<tr>
				<td style="text-align: center;background: #a1ccef;font-weight: bold">Eficacia</td>
				<td style="text-align: center;background: #a1ccef;font-weight: bold">Honradez</td>
			</tr>
			<tr>
				<td class="custom-padding">
					<el-form-item
							label=" "
							prop="provider_selected.effectivenessJustification"
							:rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

					<el-input type="textarea"
					          :autosize="{ minRows: 4, maxRows: 8}"
							  resize="none"
					          v-model="requestForm.provider_selected.effectivenessJustification"
					          :disabled="providerActive == '' ||  onlyRead== true ? true: false"/>

					</el-form-item>
				</td>
				<td class="custom-padding">

					<el-form-item
							label=" "
							prop="provider_selected.honestyJustification"
							:rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

					<el-input type="textarea"
					          :autosize="{ minRows: 4, maxRows: 8}"
							  resize="none"
					          v-model="requestForm.provider_selected.honestyJustification"
					          :disabled="providerActive == '' ||  onlyRead== true ? true: false"/>
					</el-form-item>
				</td>
			</tr>
			<tr>
				<td style="text-align: center;background: #a1ccef;font-weight: bold">Eficiencia</td>
				<td style="text-align: center;background: #a1ccef;font-weight: bold">Transparencia</td>
			</tr>
			<tr>
				<td class="custom-padding">
					<el-form-item
							label=" "
							prop="provider_selected.efficiencyJustification"
							:rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

					<el-input type="textarea"
					          :autosize="{ minRows: 4, maxRows: 8}"
							  resize="none"
					          v-model="requestForm.provider_selected.efficiencyJustification"
					          :disabled="providerActive == '' ||  onlyRead== true ? true: false"/>
					</el-form-item>
				</td>
				<td class="custom-padding">
					<el-form-item
							label=" "
							prop="provider_selected.transparencyJustification"
							:rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

					<el-input type="textarea"
					          :autosize="{ minRows: 4, maxRows: 8}"
							  resize="none"
					          v-model="requestForm.provider_selected.transparencyJustification"
					          :disabled="providerActive == '' ||  onlyRead== true ? true: false"/>
					</el-form-item>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
	import {mapState, mapGetters, mapActions, mapMutations} from "vuex"
	export default {

		props: {
			providerActive: {
				required: true
			}
		},
		computed: {
			...mapGetters("form", {
				requestForm: "requestForm",
				catalogs: "catalogs",
				general: "general",
				onlyRead: "onlyRead"
			}),
		}
	}
</script>

<style scoped>

</style>